var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningYellowIlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.782 118.003H17.2177C4.43485 118.003 -3.87899 104.546 1.83748 93.1078L43.6198 9.50934C49.9567 -3.16978 68.0432 -3.16978 74.3801 9.50934L116.162 93.1077C121.879 104.545 113.565 118.003 100.782 118.003Z",
    fill: "url(#paint0_linear_12_21610)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M100.782 118.003H17.2177C4.43485 118.003 -3.87899 104.546 1.83748 93.1078L43.6198 9.50934C49.9567 -3.16978 68.0432 -3.16978 74.3801 9.50934L116.162 93.1077C121.879 104.545 113.565 118.003 100.782 118.003Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M112.023 95.1775L70.2412 11.5792C68.066 7.22712 63.8636 4.62891 58.9999 4.62891C54.1362 4.62891 49.934 7.22712 47.7587 11.5792L5.97656 95.1775C4.01431 99.1035 4.21987 103.677 6.52664 107.41C8.83341 111.144 12.8303 113.374 17.2176 113.374H100.782C105.17 113.374 109.167 111.144 111.473 107.41C113.78 103.677 113.986 99.1037 112.023 95.1775ZM107.537 104.977C106.08 107.336 103.555 108.744 100.783 108.744H17.2176C14.4456 108.744 11.9202 107.336 10.463 104.977C9.00547 102.618 8.87563 99.7282 10.1155 97.2476L51.8977 13.6497C53.2924 10.8589 55.8808 9.25837 58.9997 9.25837C62.1186 9.25837 64.7073 10.8589 66.1018 13.6497L107.884 97.248C109.124 99.7282 108.995 102.618 107.537 104.977Z",
    fill: "#FFD761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.583 94.214C52.583 92.6054 53.2389 91.239 54.5506 90.1145C55.8625 88.9893 57.4568 88.4253 59.3309 88.4253C60.9813 88.4253 62.4079 88.9893 63.611 90.1145C64.8142 91.239 65.4178 92.6054 65.4178 94.214C65.4178 95.7579 64.8146 97.1083 63.611 98.2656C62.4079 99.4236 60.9811 100.002 59.3309 100.002C57.4566 100.002 55.8625 99.4234 54.5506 98.2656C53.2389 97.1083 52.583 95.7583 52.583 94.214ZM53.2142 37.5386C53.2142 35.9004 53.7712 34.6352 54.886 33.7438C56.0002 32.8524 57.4435 32.4062 59.2157 32.4062C60.9878 32.4062 62.2898 32.8703 63.1198 33.7978C63.9497 34.725 64.3656 35.9718 64.3656 37.5386C64.3656 42.673 64.2766 45.058 64.1026 56.6772C63.9267 68.2968 63.8399 71.9581 63.8399 77.0905C63.8399 78.1615 63.3386 78.9998 62.3376 79.6048C61.3347 80.21 60.2942 80.513 59.2159 80.513C56.0567 80.513 54.4769 79.3732 54.4769 77.0907C54.4769 71.9583 54.2662 68.297 53.8455 56.6774C53.4243 45.0578 53.2142 42.6728 53.2142 37.5386Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_21610",
    x1: 29.596,
    y1: 50.4701,
    x2: 164.257,
    y2: 185.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellowIlus);
export default __webpack_public_path__ + "static/media/warning-yellow-ilus.b473e90e6a712c939d9f1285946f57ba.svg";
export { ForwardRef as ReactComponent };